import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Row, Typography } from "antd";
import { ProductVersionModel } from '../../../models/product-interface';
import { SupportTier } from '../../../models/support-tier-interface';
import SupportRadioList from './SupportRadioList';
import { CustomerServiceQueries } from '../../../queries/customer-service-queries';

const { Title } = Typography

type Props = {
  productId: number;
  ratePlanId: string | null;
  supportTier: SupportTier;
  allSupportTiers: SupportTier[];
}

const SupportLevelCard: React.FC<Props> = ({
  productId,
  ratePlanId,
  supportTier,
  allSupportTiers
}) => {
  const [isChangingSupportLevel, setIsChangingSupportLevel] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedSupportTier, setSelectedSupportTier] = useState<number>(supportTier?.id);
  const updateSupportTierMutator = CustomerServiceQueries.useUpdateProductSupport(productId);

  useEffect(() => {
    if(!!supportTier) {
      setSelectedSupportTier(supportTier?.id);
    }
  }, [supportTier])

  const saveProductTier = () => {
    setIsLoading(true);
    let data = {
      productId,
      ratePlanId,
      supportTier: allSupportTiers.find(x => x.id == selectedSupportTier) as SupportTier
    }

    updateSupportTierMutator.mutateAsync(data).then(() => {
      setIsChangingSupportLevel(false);
    }).finally(() => {
      setIsLoading(false);
    })
  }

  return <Card className='cost-card'>
    {!isChangingSupportLevel && (
      <>
        <Title level={3}>
          {supportTier?.name}
        </Title>
        <div>
          {supportTier?.days}
        </div>
        <div>
          {supportTier?.timeString}
        </div>
        <div>
          {`${supportTier?.phone ? "Phone" : ""} ${supportTier?.phone && supportTier?.email ? "&" : ""} ${supportTier?.email ? "Email" : ""}`}
        </div>
        <Button type="link" style={{paddingLeft: 0}} onClick={() => setIsChangingSupportLevel(true)}>
          Change
        </Button>
      </>
    )}
    {isChangingSupportLevel && (
      <>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Title level={5}>
              Change Default Tier
            </Title>
          </Col>
          <Col span={24}>
            <SupportRadioList
              allSupportTiers={allSupportTiers}
              selectedSupportTierId={selectedSupportTier ?? null}
              setSelectedSupportTierId={setSelectedSupportTier}
              disabled={isLoading}
            />
          </Col>
          <Col flex="auto" />
          <Col>
            <Button onClick={() => setIsChangingSupportLevel(false)}>
              Cancel
            </Button>
          </Col>
          <Col>
            <Button
              type="primary"
              onClick={() => saveProductTier()}
              loading={isLoading}
            >
              Save
            </Button>
          </Col>
        </Row>
      </>
    )}
  </Card>
}

export default SupportLevelCard;